import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import ViteDynamicImportBackend, {
  createDebugTranslationsPlugin,
  type ViteDynamicImportBackendOptions,
} from "@exonn/i18next-vite-dynamic-import-backend";

import { getTranslationsPath } from "src/lib/i18next/getTranslationsPath.ts";
import { appStore } from "src/stores/app.store.ts";

const i18n = i18next;

const backendOptions: ViteDynamicImportBackendOptions = {
  loadPath: getTranslationsPath,
};

const debugTranslationPlugin = createDebugTranslationsPlugin({
  getRemoteUrl: (path) =>
    `https://link340.lcube-server.de/exonn-erp2/erp2-frontend/-/blob/main/${path}`,
  loadPath: getTranslationsPath,
  shouldDebug: () => appStore.debugTranslations,
});

i18next
  .use(initReactI18next)
  .use(ViteDynamicImportBackend)
  .use(debugTranslationPlugin)
  .init({
    postProcess: ["debugTranslations"],
    backend: backendOptions,
    resources: {},
    lng: localStorage.getItem("language") || "de",
    fallbackLng: "en",
    partialBundledLanguages: true,
  });

i18n.on("languageChanged", (language) => {
  localStorage.setItem("language", language);
});

export { i18n };
export default i18n;
